import { pb } from "@/utils/PocketBaseAdapter";

const getV2Origin = () => {
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:3000'
  }

  const hostParts = window.location.hostname.split('.')
  if (hostParts.length < 2) {
    return window.location.origin
  }

  const [site, ...domainParts] = hostParts
  const v2Site = site.endsWith('v2') ? site : `${site}v2`
  const v2Host = `${v2Site}.${domainParts.join('.')}`
  const port = window.location.port ? `:${window.location.port}` : ''

  return `${window.location.protocol}//${v2Host}${port}`
}

const v2Url = getV2Origin();

const HANDOFF_TOKEN_KEY = 'bbv1token'
const HANDOFF_THEME_KEY = 'bbv1theme'
const THEME_STORAGE_KEY = '-theme'

const buildV2BridgeUrl = (path: string) => {
  const token = `${pb.authStore.token || ''}`.trim()
  const themeMode = `${window.localStorage.getItem(THEME_STORAGE_KEY) || 'system'}`.trim().toLowerCase()
  const targetPath = path.startsWith('/') ? path : `/${path}`
  const bridgeUrl = new URL(`${v2Url}${targetPath}`)
  bridgeUrl.searchParams.set('navMode', 'v1bridge')

  if (token !== '') {
    bridgeUrl.hash = `${HANDOFF_TOKEN_KEY}=${encodeURIComponent(token)}`
  }

  if (['light', 'dark', 'system'].includes(themeMode)) {
    const hashParams = new URLSearchParams(bridgeUrl.hash.startsWith('#') ? bridgeUrl.hash.slice(1) : bridgeUrl.hash)
    hashParams.set(HANDOFF_THEME_KEY, themeMode)

    bridgeUrl.hash = hashParams.toString()
  }

  return bridgeUrl.toString()
}

const navigateToV2Bridge = async (path: string) => {
  const hasToken = `${pb.authStore.token || ''}`.trim() !== ''

  if (hasToken) {
    try {
      await pb.collection('users').authRefresh()
    } catch {
      return
    }
  }

  window.location.assign(buildV2BridgeUrl(path))
}

export default [

  { heading: "Admin" },
  {
    title: "Users",
    to: { name: "user" },
    icon: { icon: "mdi-account-group-outline" },
    disable: false,
  },
  {
    title: "Staffing",
    to: { name: "staffing" },
    icon: { icon: "mdi-account-clock-outline" },
    disable: false,
  },
  {
    title: "Booking List",
    to: { name: "bookinglist" },
    icon: { icon: "mdi-calendar-text-outline" },
    disable: false,
  },
  {
    title: "Events",
    to: { name: "events" },
    icon: { icon: "mdi-calendar-star" },
    disable: false,
  },
  {
    title: "Area Status",
    to: { name: "areastatus" },
    icon: { icon: "mdi-list-status" },
    disable: false,
  },
  {
    title: "Matrix Displays",
    to: { name: "matrixdisplay" },
    icon: { icon: "mdi-television" },
    disable: false,
  },
  {
    title: "Gift Vouchers",
    to: { name: "giftvouchers" },
    icon: { icon: "mdi-wallet-giftcard" },
    disable: false,
  },
  {
    title: "Discount Codes",
    to: { name: "discount-codes" },
    icon: { icon: "mdi-percent-box-outline" },
    disable: false,
  },
  {
    title: "Products",
    to: { name: "products" },
    icon: { icon: "mdi-food-outline" },
    disable: false,
  },
  {
    title: "POS cash",
    to: { name: "transactions" },
    icon: { icon: "mdi-cash-multiple" },
    disable: false,
  },
  {
    title: "Dockets",
    to: "dockets",
    icon: { icon: "mdi-cart" },
    disable: false,
  },
  {
    title: "Reports",
    href: buildV2BridgeUrl('/reports'),
    onClick: () => {
      void navigateToV2Bridge('/reports')
    },
    icon: { icon: "mdi-chart-bar" },
    disable: false,
  },
  {
    title: "Access Control",
    to: { name: "accesscontrol" },
    icon: { icon: "mdi-door-sliding-lock" },
    disable: false,
  },
  {
    title: "FAQ",
    to: { name: "faqs-admin" },
    icon: { icon: "mdi-frequently-asked-questions" },
    disable: false,
  },

  { heading: "Setup" },
  {
    title: "Location",
    to: { name: "location" },
    icon: { icon: "mdi-map-marker-outline" },
    disable: false,
  },
  {
    title: "Activities",
    to: { name: "activities" },
    icon: { icon: "mdi-golf" },
    disable: false,
  },
  {
    title: "Areas",
    to: { name: "areas" },
    icon: { icon: "mdi-map-marker-circle" },
    disable: false,
  },
  {
    title: "Advertising",
    to: { name: "advertising" },
    icon: { icon: "mdi-image" },
    disable: false,
  },
  {
    title: "Memberships",
    to: { name: "memberships" },
    icon: { icon: "mdi-account-heart-outline" },
    disable: false,
  },
  {
    title: "Coupon Types",
    to: { name: "coupontypes" },
    icon: { icon: "mdi-ticket" },
    disable: false,
  },
  {
    title: "Roles & Permissions",
    to: { name: "roles" },
    disable: false,
    icon: { icon: "mdi-shield-account-outline" },
    // children: [
    //   { title: "Roles", to: null, disable: true },
    //   { title: "Permissions", to: null, disable: true },
    // ],
  },
  {
    title: "Email Templates",
    to: { name: "emailtemplates" },
    icon: { icon: "mdi-email-multiple-outline" },
    disable: false,
  },
  {
    title: "Settings",
    to: { name: "settings" },
    icon: { icon: "mdi-cog" },
    disable: false,
  },
];
